const az: Record<string, string> = {
  'golf.common.active': 'Aktiv',
  'golf.common.admin': 'Administrator',
  'golf.common.age': 'Yaş',
  'golf.common.alert': 'Xəbərdarlıq',
  'golf.common.amount': 'Məbləğ',
  'golf.common.cancel': 'Ləğv et',
  'golf.common.close': 'Bağla',
  'golf.common.create': 'Yarat',
  'golf.common.created': 'Yaradılıb',
  'golf.common.days_fri': 'C.',
  'golf.common.days_mon': 'B.e.',
  'golf.common.days_sat': 'Ş.',
  'golf.common.days_sun': 'B.',
  'golf.common.days_thu': 'C.a.',
  'golf.common.days_tue': 'Ç.a.',
  'golf.common.days_wed': 'Ç.',
  'golf.common.delete': 'Sil',
  'golf.common.delete_confirm':
    '"{name}" zonasını silmək istədiyinizə əminsiniz?',
  'golf.common.details': 'Təfərrüatlar',
  'golf.common.discard_changes': 'Dəyişiklikləri ləğv et',
  'golf.common.draft': 'Qaralama',
  'golf.common.driving_experience': 'Sürücülük stajı',
  'golf.common.edit': 'Redaktə et',
  'golf.common.email': 'E-poçt',
  'golf.common.grant': 'İcazə ver',
  'golf.common.hourly': 'SAATLIQ',
  'golf.common.image_not_available': 'Şəkil mövcud deyil',
  'golf.common.name': 'Ad',
  'golf.common.no': 'Xeyr',
  'golf.common.not_configured': 'Konfiqurasiya edilməyib',
  'golf.common.not_uploaded': 'Yüklənməyib',
  'golf.common.parking': 'Dayanacaq',
  'golf.common.payment_card': 'KART',
  'golf.common.phone': 'Telefon',
  'golf.common.points': 'Nöqtələr',
  'golf.common.points_count': '{count} nöqtə',
  'golf.common.points_json': 'Nöqtələr (JSON)',
  'golf.common.points_json_hint':
    'Poliqon təpələri üçün {lat, lng} obyektləri massivi',
  'golf.common.protocol_4point': '4 NÖQTƏLİ PROTOKOL',
  'golf.common.quantity': 'Miqdar',
  'golf.common.reason': 'Səbəb',
  'golf.common.revoke': 'Ləğv et',
  'golf.common.save': 'Yadda saxla',
  'golf.common.save_changes': 'Dəyişiklikləri yadda saxla',
  'golf.common.select': 'Seçin',
  'golf.common.select_type': 'Növü seçin',
  'golf.common.status': 'Status',
  'golf.common.status_update_failed': 'Statusu yeniləmək mümkün olmadı',
  'golf.common.status_updated': 'Status yeniləndi',
  'golf.common.summary': 'Xülasə',
  'golf.common.system': 'Sistem',
  'golf.common.today': 'Bu gün',
  'golf.common.type': 'Növ',
  'golf.common.units': 'Vahidlər',
  'golf.common.update': 'Yenilə',
  'golf.common.updated': 'Yenilənib',
  'golf.common.user': 'İstifadəçi',
  'golf.common.yes': 'Bəli',
  'golf.dashboard.active_trips': 'AKTİV SƏFƏRLƏR',
  'golf.dashboard.approved_trips': 'TƏSDİQLƏNMİŞ SƏFƏRLƏR',
  'golf.dashboard.ready_to_start': 'Başlamağa hazır',
  'golf.dashboard.daily': 'Gündəlik',
  'golf.dashboard.dispatch_service': 'Servis qrupunu göndər',
  'golf.dashboard.end_date': 'Bitmə tarixi',
  'golf.dashboard.filtered_range': 'Seçilmiş dövr',
  'golf.dashboard.fleet_status': 'AVTOPARKIN VƏZİYYƏTİ',
  'golf.dashboard.live_on_course': 'Hazırda meydançada',
  'golf.dashboard.log_archive_future':
    'Jurnal arxivi növbəti yeniləmələrdə əlçatan olacaq',
  'golf.dashboard.low_battery_alerts': 'zəif batareya xəbərdarlığı',
  'golf.dashboard.notifications': 'Bildirişlər',
  'golf.dashboard.pending_trips': 'GÖZLƏMƏDƏ OLAN SƏFƏRLƏR',
  'golf.dashboard.period_revenue': 'DÖVR ÜZRƏ GƏLİR',
  'golf.dashboard.prev_week_growth': 'Ötən həftəyə nisbətən +5,2%',
  'golf.dashboard.requires_verification': 'Yoxlama tələb olunur',
  'golf.dashboard.service_request': 'Servis sorğusu № 12',
  'golf.dashboard.start_date': 'Başlanğıc tarixi',
  'golf.dashboard.tire_pressure_warning':
    'VIP nəqliyyat vahidi GC-002 üçün təkər təzyiqi xəbərdarlığı.',
  'golf.dashboard.title': 'İdarə paneli',
  'golf.dashboard.traffic_analytics': 'İcarə aktivliyi analitikası',
  'golf.dashboard.view_log_archive': 'Jurnal arxivinə bax →',
  'golf.financial.action_charge': 'Tut',
  'golf.financial.action_freeze': 'Blokla',
  'golf.financial.action_refund': 'Geri qaytar',
  'golf.financial.action_unfreeze': 'Blokdan çıxar',
  'golf.financial.badge_held': '[BLOKLANIB]',
  'golf.financial.badge_released': '[AZAD EDİLİB]',
  'golf.financial.charged': 'TUTULUB',
  'golf.financial.col_deposit_status': 'DEPOZİTİN STATUSU',
  'golf.financial.col_outstanding': 'ÖDƏNİLMƏMİŞ',
  'golf.financial.col_rental_fee': 'İCARƏ HAQQI',
  'golf.financial.col_renter': 'İCARƏÇİ',
  'golf.financial.col_timestamp': 'TARİX VƏ VAXT',
  'golf.financial.export_financial_report': 'Maliyyə hesabatını ixrac et',
  'golf.financial.exporting_report': 'Maliyyə hesabatı ixrac olunur...',
  'golf.financial.frozen': 'BLOKLANIB',
  'golf.financial.growth': 'ARTIM +4%',
  'golf.financial.last_month': 'Ötən ay',
  'golf.financial.manual_amount': 'ƏL İLƏ DAXİL EDİLƏN MƏBLƏĞ (₼)',
  'golf.financial.operation_type': 'ƏMƏLİYYAT NÖVÜ',
  'golf.financial.payment_activity': 'Ödəniş fəaliyyəti',
  'golf.financial.please_enter_amount': 'Zəhmət olmasa, məbləği daxil edin',
  'golf.financial.recent_deposit_service_desc':
    'Bu icarəçi üzrə son depozit və xidmət əməliyyatları.',
  'golf.financial.recent_transactions': 'Son əməliyyatlar',
  'golf.financial.refunded': 'GERİ QAYTARILIB',
  'golf.financial.renter': 'İCARƏÇİ',
  'golf.financial.select_range': 'Dövrü seçin',
  'golf.financial.service_fee': 'Xidmət haqqı',
  'golf.financial.settlement': 'Hesablaşma',
  'golf.financial.target_account': 'HƏDƏF HESAB',
  'golf.financial.this_month': 'Bu ay',
  'golf.financial.this_year': 'Bu il',
  'golf.financial.all_time': 'Bütün dövr',
  'golf.financial.title': 'Maliyyə hesabatları və ödənişlər',
  'golf.financial.total_revenue': 'ÜMUMİ GƏLİR',
  'golf.financial.transactions_title': 'ƏMƏLİYYATLAR',
  'golf.financial.valid_amount': 'Zəhmət olmasa, düzgün məbləğ daxil edin',
  'golf.fleet.actions': 'ƏMƏLİYYATLAR',
  'golf.fleet.active_in_resort': 'Kurortda aktiv',
  'golf.fleet.add_make': 'Marka əlavə et',
  'golf.fleet.add_model': 'Model əlavə et',
  'golf.fleet.all': 'Hamısı',
  'golf.fleet.asset_dialog_title': 'Nəqliyyat vahidi: {id}',
  'golf.fleet.asset_info': 'Nəqliyyat vahidi haqqında məlumat',
  'golf.fleet.assigned_make': 'TƏYİN EDİLMİŞ MARKA',
  'golf.fleet.basic_info': 'Əsas məlumatlar',
  'golf.fleet.battery': 'Batareya:',
  'golf.fleet.battery_label': '(BATAREYA)',
  'golf.fleet.browse': 'seçin',
  'golf.fleet.capacity': 'TUTUM',
  'golf.fleet.car_details': 'Qolf avtomobili haqqında məlumat',
  'golf.fleet.change_deployment_zone':
    'Yerləşdirmə zonasını dəyişmək üçün klikləyin',
  'golf.fleet.clear_zone_assignment': 'Zona təyinatını sil',
  'golf.fleet.click_select_zone':
    'İnzibatçı tərəfindən müəyyən edilmiş zonalardan seçmək üçün klikləyin',
  'golf.fleet.click_to_connect': 'Qoşulmaq üçün klikləyin',
  'golf.fleet.connect_wialon_dialog': 'Wialon GPS obyektini qoşun',
  'golf.fleet.connected_status': 'Qoşulub:',
  'golf.fleet.count_models': '{count} model',
  'golf.fleet.create_profile_subtitle':
    'Avtoparkınıza yeni qolf avtomobili modeli əlavə edin',
  'golf.fleet.create_profile_title': 'Qolf avtomobili profili yarat',
  'golf.fleet.deployment_logs_hint':
    'Yadda saxladıqdan sonra yerləşdirmə jurnalı yaradılacaq.',
  'golf.fleet.detailed_description_placeholder':
    'Bu qolf avtomobili modeli haqqında ətraflı təsviri daxil edin...',
  'golf.fleet.disconnect': 'Ayır',
  'golf.fleet.draft': 'Qaralama',
  'golf.fleet.drop_image': 'Şəkli bura sürükləyin və ya',
  'golf.fleet.eg_gc001': 'məs., GC-001',
  'golf.fleet.eg_make_name': 'məs., Denago XL və ya Club Car Tempo',
  'golf.fleet.eg_model_seats': 'məs., RXV 4 yerlik',
  'golf.fleet.eg_seats_count': 'məs., 4 və ya 2',
  'golf.fleet.eg_stall_number': 'məs., A-12',
  'golf.fleet.eg_unit_id': 'məs., 123456',
  'golf.fleet.eg_unit_name': 'məs., Golf Car 1',
  'golf.fleet.filter_by_asset_status':
    'Nəqliyyat vahidinin statusuna görə filtr:',
  'golf.fleet.filter_by_status': 'Statusa görə filtr:',
  'golf.fleet.fleet_status_logs': 'Avtoparkın status jurnalı',
  'golf.fleet.growth_plus4': 'ARTIM +4%',
  'golf.fleet.initial_asset': 'İlk nəqliyyat vahidi',
  'golf.fleet.iot_telemetry': 'IOT TELEMETRİYA',
  'golf.fleet.last_telemetry': 'Son telemetriya:',
  'golf.fleet.last_update': 'Son yeniləmə:',
  'golf.fleet.location': 'Məkan:',
  'golf.fleet.low_battery_alerts': 'Zəif batareya / servis xəbərdarlıqları',
  'golf.fleet.make_created_success': 'Qolf markası uğurla yaradıldı!',
  'golf.fleet.make_name': 'Marka adı',
  'golf.fleet.make_updated_success': 'Qolf markası uğurla yeniləndi!',
  'golf.fleet.model_created_success': 'Model uğurla yaradıldı!',
  'golf.fleet.model_id': 'MODELİN ID-Sİ',
  'golf.fleet.model_name': 'Model',
  'golf.fleet.model_updated_success': 'Model uğurla yeniləndi!',
  'golf.fleet.no_zone_assigned': 'Zona təyin edilməyib',
  'golf.fleet.physical_assets': 'NƏQLİYYAT VAHİDLƏRİ',
  'golf.fleet.profile_created_success':
    'Qolf avtomobili profili uğurla yaradıldı!',
  'golf.fleet.profile_photo': 'Profil fotosu',
  'golf.fleet.range': 'Məsafə',
  'golf.fleet.range_km': 'Məsafə (km)',
  'golf.fleet.ready': 'HAZIR',
  'golf.fleet.resort_deployment_zone': 'Kurortda yerləşdirmə zonası',
  'golf.fleet.search_wialon_placeholder': 'ID və ya ada görə axtarış...',
  'golf.fleet.select_from_catalog': 'Kataloqdan seçin...',
  'golf.fleet.showing_active_assets':
    '{total} aktiv nəqliyyat vahidindən {start}–{end} göstərilir',
  'golf.fleet.showing_active_profiles':
    '{total} aktiv profildən {start}–{end} göstərilir',
  'golf.fleet.status': 'STATUS',
  'golf.fleet.status_active': 'Aktiv',
  'golf.fleet.status_in_use': 'İstifadədə',
  'golf.fleet.status_inactive': 'Qeyri-aktiv',
  'golf.fleet.status_maintenance': 'Texniki xidmətdə',
  'golf.fleet.tab_makes': 'Qolf markaları',
  'golf.fleet.tab_models': 'Qolf modelləri',
  'golf.fleet.tariff_dialog_title': 'Tarif: {name}',
  'golf.fleet.tariffs': 'TARİFLƏR',
  'golf.fleet.telemetry_data': 'Telemetriya məlumatları',
  'golf.fleet.title': 'Avtopark idarəetməsi',
  'golf.fleet.total_fleet_models': 'Avtoparkdakı modellərin ümumi sayı',
  'golf.fleet.total_inventory': 'ÜMUMİ VAHİD SAYI',
  'golf.fleet.total_models': 'Avtoparkdakı modellərin ümumi sayı',
  'golf.fleet.unique_chassis_hint':
    'Unikal şassi nömrəsini və ya kurortun daxili nömrələməsini göstərin.',
  'golf.fleet.unit_id': 'Obyektin ID-si',
  'golf.fleet.upload_images_hint':
    'Qolf avtomobilinin 4 şəklini yükləyin (Ön, Arxa, Sol, Sağ). Hər biri maks. 10MB.',
  'golf.fleet.view': 'Bax',
  'golf.fleet.wialon_unit_id': 'Wialon obyektinin ID-si:',
  'golf.fleet.wialon_unit_name': 'WİALON OBYEKTİNİN ADI',
  'golf.header.language_az': 'Azərbaycan',
  'golf.header.language_en': 'English',
  'golf.header.language_ru': 'Русский',
  'golf.header.pending_trips_title': 'Gözləmədə olan səfər sorğuları',
  'golf.header.search_placeholder':
    'Avtomobil, istifadəçi, səfər üzrə axtarış...',
  'golf.header.select_language': 'Dil seçin',
  'golf.header.sign_out': 'Çıxış',
  'golf.map.add_area': 'Zona əlavə et',
  'golf.map.alert_area_created_success': 'Xəbərdarlıq zonası uğurla yaradıldı',
  'golf.map.alert_area_deleted_success': 'Xəbərdarlıq zonası uğurla silindi',
  'golf.map.alert_area_name_placeholder': 'Xəbərdarlıq zonasının adı',
  'golf.map.alert_area_updated_success': 'Xəbərdarlıq zonası uğurla yeniləndi',
  'golf.map.alert_areas_title': 'Xəbərdarlıq zonaları',
  'golf.map.area_created_success': 'Zona uğurla yaradıldı',
  'golf.map.area_deleted_success': 'Zona uğurla silindi',
  'golf.map.area_instructions':
    'Zonanı tənzimləmək üçün markerləri sürükləyin. Nöqtəni silmək üçün onun üzərində sağ klik edin.',
  'golf.map.area_must_have_3_points': 'Zona ən azı 3 nöqtədən ibarət olmalıdır',
  'golf.map.area_name_placeholder': 'Zonanın adı',
  'golf.map.area_updated_success': 'Zona uğurla yeniləndi',
  'golf.map.available': 'Əlçatan:',
  'golf.map.available_assets': 'Əlçatan nəqliyyat vahidləri:',
  'golf.map.create_new_alert_area': 'Yeni xəbərdarlıq zonası yarat',
  'golf.map.create_new_area': 'Yeni zona yarat',
  'golf.map.drawing_instructions_create':
    "Nöqtələr əlavə etmək üçün xəritəyə klikləyin. Bağlamaq üçün ilk nöqtəyə və ya 'Tamamla' düyməsinə klikləyin. Nöqtəni silmək üçün sağ klik edin.",
  'golf.map.edit_alert_area_details':
    'Xəbərdarlıq zonasının detallarını redaktə et',
  'golf.map.edit_area_details': 'Zonanın detallarını redaktə et',
  'golf.map.failed_delete_alert_area':
    'Xəbərdarlıq zonasını silmək mümkün olmadı',
  'golf.map.failed_delete_area': 'Zonanı silmək mümkün olmadı',
  'golf.map.failed_load_alert_areas':
    'Xəbərdarlıq zonalarını yükləmək mümkün olmadı',
  'golf.map.failed_load_areas': 'Zonaları yükləmək mümkün olmadı',
  'golf.map.failed_save_alert_area':
    'Xəbərdarlıq zonasını yadda saxlamaq mümkün olmadı',
  'golf.map.failed_save_area': 'Zonanı yadda saxlamaq mümkün olmadı',
  'golf.map.finish_drawing': 'Çəkməni tamamla',
  'golf.map.finish_editing_first':
    'Zəhmət olmasa, əvvəlcə cari zonanın redaktəsini tamamlayın',
  'golf.map.geographic_areas': 'Coğrafi zonalar',
  'golf.map.golf_car_title': 'Qolf avtomobili - {name}',
  'golf.map.initializing_map': 'Xəritə hazırlanır...',
  'golf.map.loading_map': 'Xəritə yüklənir...',
  'golf.map.no_alert_areas_found': 'Xəbərdarlıq zonası tapılmadı.',
  'golf.map.no_areas_found': 'Zona tapılmadı.',
  'golf.map.parking_areas': 'Dayanacaq zonaları',
  'golf.map.refresh_map': 'Xəritəni yenilə',
  'golf.map.title': 'Xəritə',
  'golf.map.total_golf_cars': 'Ümumi qolf avtomobilləri:',
  'golf.map.visible': 'Görünən:',
  'golf.map.zoom_in': 'Yaxınlaşdır',
  'golf.map.zoom_out': 'Uzaqlaşdır',
  'golf.menu.alert_areas': 'Xəbərdarlıq zonaları',
  'golf.menu.areas': 'Zonalar',
  'golf.menu.brand': 'Breeze Golf',
  'golf.menu.brand_subtitle': 'Rəhbər kabineti',
  'golf.menu.dashboard': 'İdarə paneli',
  'golf.menu.financial_reports': 'Maliyyə hesabatları və ödənişlər',
  'golf.menu.fleet': 'Avtopark idarəetməsi',
  'golf.menu.fleet_typo': 'Avtopark idarəetməsi',
  'golf.menu.map': 'Xəritə',
  'golf.menu.reserves': 'Rezervasiyalar',
  'golf.menu.settings': 'Parametrlər',
  'golf.menu.switch_ev': 'EV MODULU',
  'golf.menu.switch_golf': 'QOLF MODULU',
  'golf.menu.switch_p2p': 'P2P MODULU',
  'golf.menu.tariffs_settings': 'Tariflər və parametrlər',
  'golf.menu.trips': 'Səfərlər',
  'golf.menu.user_role': 'İstifadəçi rolları',
  'golf.menu.users': 'İstifadəçilər',
  'golf.menu.users_access': 'İstifadəçi rolları',
  'golf.promo.action_pause': 'Fasilə ver',
  'golf.promo.action_resume': 'Davam etdir',
  'golf.promo.action_stop': 'Dayandır',
  'golf.promo.active': 'Aktiv',
  'golf.promo.active_campaigns': 'Aktiv kampaniyalar',
  'golf.promo.add_discount': 'Yeni endirim əlavə et',
  'golf.promo.all_campaigns': 'Bütün promo kampaniyalar',
  'golf.promo.all_statuses': 'Bütün statuslar',
  'golf.promo.all_users': 'Bütün istifadəçilər',
  'golf.promo.always_active': 'Həmişə aktiv',
  'golf.promo.applies_to_all_tariffs_default':
    'Standart olaraq bütün tariflərə tətbiq olunur',
  'golf.promo.btn_auto_generate': 'Avtomatik yarat',
  'golf.promo.btn_create_campaign': 'Kampaniya yarat',
  'golf.promo.budget_limit': 'Büdcə limiti (₼)',
  'golf.promo.budget_prefix': 'Büdcə:',
  'golf.promo.bulk_generate': 'Toplu yarat',
  'golf.promo.bulk_generate_title':
    '12 simvollu promokodların toplu yaradılması',
  'golf.promo.campaign_name': 'Kampaniyanın adı',
  'golf.promo.col_code_campaign': 'KOD VƏ KAMPANİYA',
  'golf.promo.col_conditions': 'ŞƏRTLƏR',
  'golf.promo.col_discount': 'ENDİRİM',
  'golf.promo.col_usages_budget': 'İSTİFADƏ VƏ BÜDCƏ',
  'golf.promo.col_validity': 'QÜVVƏDƏ OLMA MÜDDƏTİ',
  'golf.promo.completed_redemptions': 'Tamamlanmış səfərlərdə istifadə',
  'golf.promo.copy_code': 'Kodu kopyala',
  'golf.promo.create_promo_code': 'Promokod yarat',
  'golf.promo.currently_redeemable':
    'Hazırda qonaqlar tərəfindən istifadə edilə bilər',
  'golf.promo.customer_savings': 'MÜŞTƏRİLƏRİN ÜMUMİ QƏNAƏTİ',
  'golf.promo.dialog_create_campaign': 'Promo kampaniya yarat',
  'golf.promo.discount': 'ENDİRİM',
  'golf.promo.discount_type': 'Endirim növü',
  'golf.promo.discount_value': 'Endirim dəyəri',
  'golf.promo.eg_campaign_name': 'məs., Yay Golf Open 2026',
  'golf.promo.export_csv': 'CSV ixrac et',
  'golf.promo.failed_save_promo': 'Promokodu yadda saxlamaq mümkün olmadı',
  'golf.promo.failed_stop_promo': 'Promokodu dayandırmaq mümkün olmadı',
  'golf.promo.fixed_amount': 'Sabit məbləğ (₼)',
  'golf.promo.label_applicable_tariffs': 'Tətbiq olunan tariflər',
  'golf.promo.label_code_12_chars': 'Promokod (12 simvol)',
  'golf.promo.label_max_discount_cap': 'Maksimum endirim həddi (₼)',
  'golf.promo.label_min_order': 'Minimum sifariş məbləği (₼)',
  'golf.promo.label_restrict_new_users':
    'Yalnız ilk dəfə icarə edənlər üçün (Yeni istifadəçilər)',
  'golf.promo.label_usage_limit_total': 'İstifadə limiti (ümumi)',
  'golf.promo.label_valid_from': 'Başlama tarixi',
  'golf.promo.label_valid_until': 'Bitmə tarixi',
  'golf.promo.max_prefix': 'Maks.:',
  'golf.promo.min_prefix': 'Min.:',
  'golf.promo.must_be_12_chars':
    '12 böyük hərf və ya rəqəmdən ibarət olmalıdır.',
  'golf.promo.new_users_only': 'Yalnız yeni istifadəçilər',
  'golf.promo.no_promo_codes_found': 'Promokod tapılmadı',
  'golf.promo.paused': 'Dayandırılıb',
  'golf.promo.percentage': 'Faiz (%)',
  'golf.promo.placeholder_12_chars': '12 SİMVOLLU KOD',
  'golf.promo.placeholder_optional_cap': 'İstəyə bağlı hədd',
  'golf.promo.placeholder_optional_min': 'İstəyə bağlı minimum',
  'golf.promo.placeholder_unlimited': 'Boş qalarsa, limitsiz',
  'golf.promo.prefix_max6': 'Prefiks (Maks. 6)',
  'golf.promo.promo_code': 'Promokod',
  'golf.promo.promo_code_saved': 'Promokod uğurla yaradıldı',
  'golf.promo.promo_codes': 'Promokodlar',
  'golf.promo.search_placeholder': 'Kod və ya kampaniya üzrə axtarış...',
  'golf.promo.spent_budget': 'Xərclənmiş büdcə',
  'golf.promo.status_expired': 'Müddəti bitib',
  'golf.promo.status_stopped': 'Dayandırılıb',
  'golf.promo.subtitle':
    '12 simvollu promo kampaniyaları, endirim faizlərini, büdcə limitlərini və statusları idarə edin.',
  'golf.promo.target_audience': 'Hədəf auditoriyası',
  'golf.promo.title': 'Promokod sistemi',
  'golf.promo.total_active_label': 'Cəmi aktiv:',
  'golf.promo.total_campaigns': 'Kampaniyaların ümumi sayı',
  'golf.promo.total_cumulative_discount': 'Verilmiş endirimlərin ümumi məbləği',
  'golf.promo.total_redemptions_label': 'Cəmi istifadə:',
  'golf.promo.total_usages': 'Ümumi istifadə sayı',
  'golf.promo.uses': 'İstifadə sayı:',
  'golf.promo.validity_window': 'Qüvvədə olma müddəti',
  'golf.promo.wallet_credit': 'Cüzdan krediti (₼)',
  'golf.reserves.active_reservations': 'AKTİV REZERVASİYALAR',
  'golf.reserves.failed_load_reserves':
    'Rezervasiyaları yükləmək mümkün olmadı',
  'golf.reserves.filter_payment': 'Ödənişə görə filtr',
  'golf.reserves.no_active_reservations': 'Aktiv rezervasiya yoxdur',
  'golf.reserves.reservation_info': 'Rezervasiya haqqında məlumat',
  'golf.reserves.title': 'Rezervasiyalar',
  'golf.reserves.upcoming_cancelled_desc':
    'Bu istifadəçiyə aid qarşıdakı və ya ləğv edilmiş rezervasiyalar.',
  'golf.roles.access_except_users':
    'İstifadəçilər və giriş idarəetməsi XARİC bütün modullara giriş',
  'golf.roles.access_revoked': 'Giriş icazəsi ləğv edildi',
  'golf.roles.admin': 'Administrator',
  'golf.roles.col_last_active_timestamp': 'SON AKTİVLİK VAXTI',
  'golf.roles.col_module_permissions': 'MODUL İCAZƏLƏRİ',
  'golf.roles.col_team_member': 'KOMANDA ÜZVÜ',
  'golf.roles.edit_team_member': 'Komanda üzvünü redaktə et',
  'golf.roles.eg_email': 'ad@sirket.com',
  'golf.roles.eg_first_name': 'məs., Əli',
  'golf.roles.eg_last_name': 'məs., Məmmədov',
  'golf.roles.email': 'E-poçt',
  'golf.roles.failed_revoke': 'Giriş icazəsini ləğv etmək mümkün olmadı',
  'golf.roles.failed_update_role': 'Rolu yeniləmək mümkün olmadı',
  'golf.roles.full_system_access': 'Bütün modullarda sistemə tam giriş',
  'golf.roles.invitation_sent': 'Dəvət uğurla göndərildi',
  'golf.roles.invite_team_member': 'Yeni komanda üzvü dəvət et',
  'golf.roles.name': 'Ad',
  'golf.roles.operator': 'Operator',
  'golf.roles.operator_access_desc':
    'Yalnız İdarə paneli, Səfərlər, Avtopark. Tariflər, İstifadəçilər və əl ilə ödənişlər bloklanıb.',
  'golf.roles.revoke_access': 'Giriş icazəsini ləğv et',
  'golf.roles.role': 'Rol',
  'golf.roles.role_admin_desc': 'Bütün modullar aktivdir',
  'golf.roles.role_blocked_desc':
    '(Tariflər, İstifadəçilər və əl ilə ödənişlər bloklanıb)',
  'golf.roles.role_operator_desc':
    'Yalnız İdarə paneli, Səfərlər, Avtopark idarəetməsi',
  'golf.roles.role_supervisor_desc':
    'İdarə paneli, Səfərlər, Avtopark idarəetməsi, Maliyyə hesabatları və ödənişlər (İstifadəçilər bölməsi deaktivdir)',
  'golf.roles.select_role': 'Rol seçin',
  'golf.roles.send_secure_token':
    'E-poçt vasitəsilə təhlükəsiz qoşulma tokeni göndərin',
  'golf.roles.supervisor': 'Supervayzer',
  'golf.roles.title': 'İstifadəçi rolları',
  'golf.roles.total_active_admins': 'Aktiv administrator hesablarının sayı:',
  'golf.roles.total_active_field': 'Aktiv sahə əməkdaşlarının sayı:',
  'golf.roles.update_role_for': '{name} üçün rolu yeniləyin',
  'golf.roles.user_role_updated': 'İstifadəçi rolu yeniləndi',
  'golf.tariffs.applies_strictly_first_hour':
    'Yalnız icarənin ilk saatına tətbiq olunur.',
  'golf.tariffs.base_hourly_rate': 'Əsas saatlıq tarif (₼)',
  'golf.tariffs.base_weekend_rate': 'Əsas həftə sonu tarifi – cümə–bazar (₼)',
  'golf.tariffs.base_workday_rate':
    'Əsas iş günü tarifi – bazar ertəsi–cümə axşamı (₼)',
  'golf.tariffs.create_tariff': 'Tarif yarat',
  'golf.tariffs.daily_price_calibration': 'Günlük qiymətlərin tənzimlənməsi',
  'golf.tariffs.daily_price_calibration_desc':
    'Əsas günlük tarifləri və uzunmüddətli icarə üçün pilləli endirimləri təyin edin.',
  'golf.tariffs.daily_pricing': 'Günlük qiymətlər',
  'golf.tariffs.durations_min': 'Mövcud müddətlər (dəq)',
  'golf.tariffs.eligibility_guards': 'Uyğunluq tələbləri və təminat depoziti',
  'golf.tariffs.eligibility_guards_desc':
    'Risklərin idarə edilməsi və maliyyə təhlükəsizliyi qaydaları.',
  'golf.tariffs.failed_update_tariff': 'Tarifi yeniləmək mümkün olmadı',
  'golf.tariffs.fixed_30min_help':
    'İstifadəçi 30 dəqiqəlik qısa icarə paketini seçdikdə avtomatik tətbiq olunan sabit əsas qiymət.',
  'golf.tariffs.fixed_30min_rate': 'Sabit 30 dəqiqəlik paket tarifi (₼)',
  'golf.tariffs.fixed_security_deposit': 'Sabit təminat depoziti (₼)',
  'golf.tariffs.formula_preview_for': '{model} üçün düstur önizləməsi:',
  'golf.tariffs.global_tariffs': 'Ümumi tariflər',
  'golf.tariffs.hourly_price_calibration': 'Saatlıq qiymətlərin tənzimlənməsi',
  'golf.tariffs.hourly_pricing': 'Saatlıq qiymətlər',
  'golf.tariffs.hours_formula_preview': '{hours} saat = {formula}',
  'golf.tariffs.per_day': '/gün',
  'golf.tariffs.per_hour': '/saat',
  'golf.tariffs.short_term_economics_desc':
    'Qısa müddətli qonaqlar üçün qısamüddətli icarə qiymətlərini müəyyən edin.',
  'golf.tariffs.subsequent_hour_discount': 'Növbəti saatlar üçün endirim (%)',
  'golf.tariffs.subsequent_hour_discount_help':
    'Yalnız ilk saatdan sonrakı saatlara tətbiq olunan sabit endirim.',
  'golf.tariffs.tariff_save_failed':
    'Konfiqurasiyanı yadda saxlamaq mümkün olmadı.',
  'golf.tariffs.tariff_saved_success': 'Konfiqurasiya uğurla yadda saxlanıldı.',
  'golf.tariffs.tier_1': '1-ci pillə (2–7 gün)',
  'golf.tariffs.tier_2': '2-ci pillə (8–14 gün)',
  'golf.tariffs.tier_3': '3-cü pillə (15–30 gün)',
  'golf.tariffs.tier_4': '4-cü pillə (31 gün və daha çox)',
  'golf.tariffs.title': 'Tariflər və parametrlər',
  'golf.tariffs.weekend': 'Həftə sonu',
  'golf.tariffs.weekend_rate_label': 'Həftə sonu tarifi (₼)',
  'golf.tariffs.workday': 'İş günü',
  'golf.tariffs.workday_rate_label': 'İş günü tarifi (₼)',
  'golf.tariffs.your_savings': '(Qənaətiniz: {amount})',
  'golf.trips.account_verified': 'Hesab təsdiqlənib',
  'golf.trips.accumulated_extensions': 'Səfərin ümumi uzadılmaları',
  'golf.trips.action_col': 'Əməliyyat',
  'golf.trips.action_required': 'ƏMƏLİYYAT TƏLƏB OLUNUR',
  'golf.trips.actions': 'Əməliyyatlar',
  'golf.trips.actor_col': 'İcraçı',
  'golf.trips.additional_charge_applied': 'Əlavə ödəniş hesablandı.',
  'golf.trips.after_trip_photos': 'Səfərdən sonrakı fotolar',
  'golf.trips.amounts_label': 'Məbləğlər',
  'golf.trips.approve': 'Təsdiqlə',
  'golf.trips.assign_model': 'Modeli təyin et',
  'golf.trips.assigned_stall': 'Təyin edilmiş dayanacaq yeri',
  'golf.trips.base_rate_label': 'Əsas tarif',
  'golf.trips.base_rental_service_fee': 'Əsas icarə xidmət haqqı',
  'golf.trips.booking_details': 'Rezervasiya təfərrüatları',
  'golf.trips.cancel_trip': 'Səfəri ləğv et',
  'golf.trips.cash': 'NAĞD',
  'golf.trips.cash_payment_notice':
    'Bu səfər kassada nağd pulla ödənilib. Kart üzrə bloklama və ya silinmə əməliyyatı aparılmayıb.',
  'golf.trips.change_model_manually': 'Modeli əl ilə dəyiş',
  'golf.trips.charge_amount': 'Tutulan məbləğ',
  'golf.trips.comment_col': 'Şərh',
  'golf.trips.complete_trip': 'Səfəri tamamla',
  'golf.trips.confirm_cash_settlement': 'NAĞD HESABLAŞMANI TƏSDİQLƏ',
  'golf.trips.credit': 'KART',
  'golf.trips.current_status': 'CARİ STATUS',
  'golf.trips.daily_rental': 'GÜNLÜK İCARƏ',
  'golf.trips.date_col': 'Tarix',
  'golf.trips.decline': 'Rədd et',
  'golf.trips.deposit': 'Depozit',
  'golf.trips.discounts_applied': 'Tətbiq edilmiş endirimlər',
  'golf.trips.extended_by_user': 'İstifadəçi tərəfindən uzadılıb',
  'golf.trips.failed_assign_model': 'Modeli təyin etmək mümkün olmadı',
  'golf.trips.failed_copy_id': 'ID-ni kopyalamaq mümkün olmadı',
  'golf.trips.financials': 'Maliyyə',
  'golf.trips.finish_log_transaction': 'TAMAMLA VƏ ƏMƏLİYYATI QEYDƏ AL',
  'golf.trips.freeze_amount': 'Bloklanmış məbləğ',
  'golf.trips.freeze_order_id': 'Bloklama sifarişinin ID-si',
  'golf.trips.hourly_rental': 'SAATLIQ İCARƏ',
  'golf.trips.id_copied': 'ID mübadilə buferinə kopyalandı',
  'golf.trips.is_cash': 'Nağddır',
  'golf.trips.lifecycle_status': 'Səfərin statusu',
  'golf.trips.lifestyle_status': 'Səfərin statusu',
  'golf.trips.live_preview_box': 'CANLI ÖNİZLƏMƏ',
  'golf.trips.log_booking_approved': 'Rezervasiya təsdiqləndi',
  'golf.trips.log_booking_created': 'Rezervasiya yaradıldı',
  'golf.trips.log_booking_declined': 'Rezervasiya rədd edildi',
  'golf.trips.log_trip_cancelled': 'Səfər ləğv edildi',
  'golf.trips.log_trip_completed': 'Səfər tamamlandı',
  'golf.trips.log_trip_put_on_hold': 'Səfər müvəqqəti dayandırıldı',
  'golf.trips.log_trip_resumed': 'Səfər davam etdirildi',
  'golf.trips.log_trip_started': 'Səfər başladı',
  'golf.trips.manual_desk_reconciliation': 'Bu səfər üzrə əl ilə hesablaşma',
  'golf.trips.model_assigned_success': 'Model səfərə uğurla təyin edildi',
  'golf.trips.model_id': 'Modelin ID-si',
  'golf.trips.no_aftertrip_photos': 'Səfərdən sonrakı foto yoxdur',
  'golf.trips.no_logs_available': 'Bu səfər üzrə jurnal qeydi yoxdur',
  'golf.trips.no_pretrip_photos': 'Səfərdən əvvəlki foto yoxdur',
  'golf.trips.no_trips_found': 'Səfər tapılmadı',
  'golf.trips.payment_details': 'Ödəniş təfərrüatları',
  'golf.trips.payment_id': 'Ödənişin ID-si',
  'golf.trips.payment_method': 'Ödəniş üsulu',
  'golf.trips.payment_status': 'Ödəniş statusu',
  'golf.trips.per_minute_rental': 'DƏQİQƏLİK İCARƏ',
  'golf.trips.pickup': 'TƏHVİL ALMA',
  'golf.trips.post_trip_return': 'SƏFƏRDƏN SONRA QAYTARMA',
  'golf.trips.pre_trip_photos': 'Səfərdən əvvəlki fotolar',
  'golf.trips.pre_trip_verification': 'SƏFƏRDƏN ƏVVƏL YOXLAMA',
  'golf.trips.put_on_hold': 'Müvəqqəti dayandır',
  'golf.trips.refund_amount': 'Geri qaytarılan məbləğ',
  'golf.trips.renter_profile': 'İcarəçi profili',
  'golf.trips.resume_trip': 'Səfəri davam etdir',
  'golf.trips.return': 'QAYTARMA',
  'golf.trips.seats': 'Oturacaq sayı',
  'golf.trips.select_available_model_placeholder': 'Mövcud modeli seçin...',
  'golf.trips.select_model_catalog': 'SİSTEMDƏ MÖVCUD MODELİ SEÇİN',
  'golf.trips.showing_active_models_fleet':
    'Təyinat üçün avtopark üzrə bütün aktiv modellər göstərilir.',
  'golf.trips.showing_results': '{total} nəticədən {start}–{end} göstərilir',
  'golf.trips.stall': 'Dayanacaq yeri',
  'golf.trips.stall_number': 'Dayanacaq yerinin nömrəsi',
  'golf.trips.start_trip': 'Səfərə başla',
  'golf.trips.status_cancelled_admin': 'Ləğv edilmiş (Administrator)',
  'golf.trips.status_cancelled_user': 'Ləğv edilmiş (İstifadəçi)',
  'golf.trips.tab_all': 'Bütün səfərlər',
  'golf.trips.tab_approved': 'Təsdiqlənmiş',
  'golf.trips.tab_cancelled': 'Ləğv edilmiş',
  'golf.trips.tab_completed': 'Tamamlanmış',
  'golf.trips.tab_on_hold': 'Müvəqqəti dayandırılmış',
  'golf.trips.tab_ongoing': 'Davam edən',
  'golf.trips.tab_pending': 'Gözləmədə',
  'golf.trips.title': 'Səfərlər',
  'golf.trips.total_amount_label': 'Ümumi məbləğ',
  'golf.trips.total_cash_due': 'NAĞD ÖDƏNİLƏCƏK ÜMUMİ MƏBLƏĞ',
  'golf.trips.total_credit_due': 'KARTLA ÖDƏNİLƏCƏK ÜMUMİ MƏBLƏĞ',
  'golf.trips.trigger_action': 'ƏMƏLİYYATI İCRA ET',
  'golf.trips.trip_details': 'Səfər təfərrüatları',
  'golf.trips.trip_extended_user': 'Səfər istifadəçi tərəfindən uzadıldı',
  'golf.trips.trip_finance': 'SƏFƏR ÜZRƏ MALİYYƏ',
  'golf.trips.trip_logs': 'SƏFƏR JURNALI',
  'golf.trips.trip_photos': 'SƏFƏR FOTOLARI',
  'golf.trips.trip_status': 'Səfərin statusu',
  'golf.trips.trip_total': 'Səfərin ümumi məbləği',
  'golf.trips.vehicle_model': 'Avtomobil modeli',
  'golf.trips.view_details': 'Ətraflı bax',
  'golf.users.account_profile': 'HESAB PROFİLİ',
  'golf.users.audit_documentation': 'YOXLAMA ÜÇÜN SƏNƏDLƏR',
  'golf.users.balance': 'Balans',
  'golf.users.base': 'Baza',
  'golf.users.block': 'Blokla',
  'golf.users.copy_user_id': 'İstifadəçi ID-sini kopyala',
  'golf.users.current_balance': 'Cari balans:',
  'golf.users.description': 'Təsvir',
  'golf.users.driver_license': 'Sürücülük vəsiqəsi',
  'golf.users.failed_update_status': 'Statusu yeniləmək mümkün olmadı',
  'golf.users.filter_golf_status': 'Qolf statusuna görə filtr',
  'golf.users.golf_statistics': 'QOLF STATİSTİKASI',
  'golf.users.identifications': 'ŞƏXSİYYƏTİ TƏSDİQ EDƏN SƏNƏDLƏR',
  'golf.users.last_trip_date': 'Son səfər tarixi',
  'golf.users.latest_bookings_desc': 'Bu icarəçinin son rezervasiyaları.',
  'golf.users.latest_reserves': 'Son rezervasiyalar',
  'golf.users.linked_cards_desc': 'Bu icarəçinin hesabına bağlı kartlar.',
  'golf.users.loaded': 'yüklənib',
  'golf.users.no_cards_on_file': 'Qeydiyyatda ödəniş kartı yoxdur',
  'golf.users.no_financial_operations':
    'Hələlik maliyyə əməliyyatı qeydə alınmayıb',
  'golf.users.no_reserves_found':
    'Bu istifadəçi üçün qolf avtomobili rezervasiyası tapılmadı',
  'golf.users.no_trips_recorded': 'Bu icarəçi üçün səfər qeydə alınmayıb',
  'golf.users.no_trips_yet': 'Hələlik səfər yoxdur',
  'golf.users.not_set': 'Təyin edilməyib',
  'golf.users.on_file': 'qeydiyyatda',
  'golf.users.operation': 'Əməliyyat',
  'golf.users.outstanding_amount_warning':
    'İstifadəçi yenidən bron etməzdən əvvəl borc məbləği ödənilməlidir.',
  'golf.users.passport_id': 'Pasport və ya şəxsiyyət vəsiqəsi',
  'golf.users.payment_cards': 'Ödəniş kartları',
  'golf.users.pricing': 'Qiymətləndirmə',
  'golf.users.recent_trips': 'Son səfərlər',
  'golf.users.renter_access_desc':
    'Bu istifadəçinin Qolf moduluna girişi var və icarəçi kimi səfər bron edə bilər.',
  'golf.users.reserve': 'Rezervasiya',
  'golf.users.reserved_window': 'Rezervasiya müddəti',
  'golf.users.title': 'İstifadəçilər',
  'golf.users.total_trips': 'Ümumi səfərlər',
  'golf.users.trip': 'Səfər',
  'golf.users.unblock': 'Blokdan çıxar',
  'golf.users.user_info': 'İSTİFADƏÇİ MƏLUMATLARI',
  'golf.users.user_status_updated': 'İstifadəçi statusu uğurla yeniləndi',
  'golf.users.users_exported': 'İstifadəçilər uğurla ixrac edildi',
  'golf.users.wallet_state_desc':
    'Bu icarəçinin qolf səfərləri üzrə cüzdan vəziyyəti.',
  'golf.users.years': 'yaş',
  'golf.zones.title': 'Kurortda yerləşdirmə zonası',
}
export default az
